import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperMissionShoppingPage } from './shopper-mission-shopping';

@NgModule({
  declarations: [
    ShopperMissionShoppingPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperMissionShoppingPage),
    TranslateModule.forChild()
  ],
})
export class ShopperMissionShoppingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission-shopping/shopper-mission-shopping.module.ts